module.exports = __webpack_public_path__ + "static/img/contant_1.9e5d663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/contant_1.jpg
// module id = JF8z
// module chunks = 0